import React from "react";
import HerroSection from "../components/NewsPage/HerroSection";
import MainSectionHeader from "../components/NewsPage/MainSectionHeader";

const News = () => {
  return (
    <div>
      <HerroSection />
      <MainSectionHeader />
    </div>
  );
};

export default News;
